import { createTheme } from '@mantine/core';

import colors from './colors';

const theme = createTheme({
  fontFamily: 'Archivo, sans-serif',
  headings: { fontWeight: '400', fontFamily: 'Archivo, sans-serif' },
  primaryColor: 'plum',
  colors,
  fontSizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
    '4xl': '36px',
    '5xl': '48px'
  },
  defaultRadius: '4px',
  cursorType: 'pointer'
});

export default theme;
